
import Backbone from 'backbone'
import Cocktail from 'backbone.cocktail'
import HitAreaLayerModel from '../models/HitAreaLayerModel'
import LayerModel from '../models/LayerModel'
import MapModelMixin from './mixins/MapModelMixin'
import UnitLayerModel from '../models/UnitLayerModel'

class LayerCollection extends Backbone.Collection {
  
  model(attrs, options) {
    switch (attrs.type) {
      case 'HitAreaLayer': return new HitAreaLayerModel(attrs, options)
      case 'UnitLayer': return new UnitLayerModel(attrs, options)
      default: return new LayerModel(attrs, options)
    }
  }
}

Cocktail.mixin(LayerCollection, MapModelMixin);

export default LayerCollection
